module.exports = __webpack_public_path__ + "img/magic_light_ic.f6e3e6f0.png";